import settings from '../constants/settings.js';
import * as browserCheck from '../utils/browserCheck.js';

class WidgetService {
    
        static initialiseFacebook() {
            //initialise facebook widget
            if(!window.fbAsyncInit) {
                window.fbAsyncInit = function () {
                    window.FB.init({
                        appId: settings.FACEBOOK_APP_ID,
                        xfbml: true,
                        version: 'v2.11'
                    });
                };
            }
            if(!window.FB) {
                (function (d, s, id) {
                    let js, fjs = d.getElementsByTagName(s)[0];
                    if (d.getElementById(id)) { return; }
                    js = d.createElement(s); js.id = id;
                    js.src = "//connect.facebook.net/en_US/sdk.js?version=v2.11";
                    fjs.parentNode.insertBefore(js, fjs);
                }(document, 'script', 'facebook-jssdk'));
            }
        }
    
        static initialiseTwitter() {
            if(!window.twttr) {
                //$.getScript('https://platform.twitter.com/widgets.js');
                window.twttr = (function(d, s, id) {
                    var js, fjs = d.getElementsByTagName(s)[0],
                      t = window.twttr || {};
                    if (d.getElementById(id)) return t;
                    js = d.createElement(s);
                    js.id = id;
                    js.src = "https://platform.twitter.com/widgets.js";
                    fjs.parentNode.insertBefore(js, fjs);
                  
                    t._e = [];
                    t.ready = function(f) {
                      t._e.push(f);
                    };
                  
                    return t;
                  }(document, "script", "twitter-wjs"));
            }
        }

        static initialiseMagnific(controls) {
            if (browserCheck.canUseDom()) {
                require('magnific-popup');
                controls.magnificPopup({
                    disableOn: 700,
                    type: 'iframe',
                    iframe: {
                        markup: '<div class="mfp-iframe-scaler">' +
                                '<div class="mfp-close"></div>' +
                                '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
                                '<div class="mfp-title-holder"><div class="mfp-title">Some caption</div></div>' +
                                '</div>'
                    },
                    callbacks: {
                        markupParse: function (template, values, item) {
                            values.title = item.el.attr('title');
                        }
                    },
                    mainClass: 'mfp-fade',
                    removalDelay: 160,
                    preloader: false,
                    fixedContentPos: false
                });
            }
        }

        static initialiseMagnificGallery(control, items) {
            if (browserCheck.canUseDom()) {
                require('magnific-popup');
                control.magnificPopup({
                    items: items,
                    type: 'image',
                    tLoading: 'Loading image #%curr%...',
                    mainClass: 'mfp-img-mobile',
                    gallery: {
                        enabled: true,
                        navigateByImgClick: true,
                        preload: [0,1]
                    },
                    image: {
                        tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
                    }
                });
            }
        }
    }

    export default WidgetService;